import { useEffect, useState } from "react";
import { getRecentlyViewed } from "@/lib/recentlyViewed";
import { ProductCard } from "@/components/ProductCard";
import { useCart } from "@/context/CartContext";
import { Reveal } from "@/components/Reveal";

export const RecentlyViewed = ({ excludeSlug, title = "Recently Viewed", subtitle }) => {
  const { addItem } = useCart();
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getRecentlyViewed().filter((p) => p.slug !== excludeSlug).slice(0, 4));
  }, [excludeSlug]);

  if (items.length === 0) return null;

  return (
    <section className="max-w-[1400px] mx-auto px-5 sm:px-8 py-14" data-testid="recently-viewed">
      <Reveal>
        <div className="mb-8">
          <h2 className="font-display text-3xl sm:text-4xl tracking-tight">{title}</h2>
          {subtitle && <p className="text-sm text-[#6E6E69] mt-1">{subtitle}</p>}
        </div>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-10">
        {items.map((p, i) => (
          <ProductCard key={p.slug} product={p} index={i} onAdd={(pr, s) => addItem(pr, s)} />
        ))}
      </div>
    </section>
  );
};
